import { render } from "./Survey.vue?vue&type=template&id=1b6d170b"
import script from "./Survey.vue?vue&type=script&lang=js"
export * from "./Survey.vue?vue&type=script&lang=js"

import "./Survey.vue?vue&type=style&index=0&id=1b6d170b&scope=true&lang=scss"
script.render = render

export default script